<template>
  <div :class="`module-news-filter module-news-filter--${layout}`" ref="container">
    <div class="filter__title" @click="showOptions = !showOptions">
      <span>{{ label }}</span>
    </div>
    <div class="filter__options" v-if="showOptions">
      <div class="options__option" :class="{ '-checked': selectedOptions.includes(option.uid) }" v-for="(option, key) in options" :key="`${identifier}-${key}`">
        <label :for="`${identifier}-${key}`">
          <input :type="layout" :id="`${identifier}-${key}`" :value="option.uid" v-model="selectedOptions">
          <span>{{ option.name }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showOptions: false,
      selectedGroups: []
    }
  },
  props: {
    identifier: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    // [{ title: 'group1', options: [{ label: "option1", value: "1" }, { label: "option2", value: "2" }, ...] }, ...]
    options: {
      type: Array,
      default: () => ([])
    },
    value: {
      type: Array,
      default: () => ([])
    },
    layout: {
      type: String,
      default: 'checkbox'
    }
  },
  computed: {
    selectedOptions: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  created () {
    const self = this

    document.addEventListener('mousedown', event => {
      if (self.$refs && self.$refs.container && !self.$refs.container.contains(event.target)) {
        self.showOptions = false
      }
    })
  }
}
</script>
